import { toast } from "react-toastify";
import { useFetchIssueDetailViewQuery } from "../../slice/logdetailSlice";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { IoIosArrowBack } from "react-icons/io";
import { IoDocumentTextOutline } from "react-icons/io5";
import FileUpload from "./FileUpload";
import { addDocument, deleteCommentEntities, fetchEntityById } from "../../apis/apiService";
import { BtnLoader } from "./Loader";
import { useSelector } from "react-redux";
import { Avatar, Box, Tooltip } from "@mui/material";
import { useTheme } from "../../ThemeContext";
import Swal from "sweetalert2";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Counter from "yet-another-react-lightbox/plugins/counter";
import "yet-another-react-lightbox/plugins/counter.css";
import { useParams } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import { LuDownload } from "react-icons/lu";
import { RiDeleteBin6Line } from "react-icons/ri";
import { openInNewTab } from "../../utils/openInNewTab";



const AddDocumentComponent = ({
  onApply,
  onClear,
  onCancel,
  onDocumentAdded,
  id,
  refetchList,
  type,
}) => {
  const { handleSubmit, reset } = useForm({
    defaultValues: {
      uploadedFiles: [],
    },
  });

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  //  const { id } = useParams();
  // const { data: issue_detail, refetch } =
   useFetchIssueDetailViewQuery(id);
  const onSubmit = async (data) => {
    console.log("upload_data :", data);

    setLoading(true);
    // const finalData = { ...data, uploadedFile };
    if (!uploadedFiles.length) {
      // Check if the array is empty
      console.error("Please upload a file before submitting.");
      toast.error("Please upload a file before submitting.");
      return;
    }

    try {
      const resourceType = type;
      const resourceId = id;
      const responses = await addDocument(resourceType, resourceId, uploadedFiles);
      toast.success(responses.message || "Document successfully uploaded!");
      refetchList();
      reset();
      setUploadedFiles([]); // Clear the uploaded file

      // setUploadSuccess(true);
      if (onDocumentAdded) {
        onDocumentAdded();
      }
    } 
    catch (error) {
      // console.error('Failed to upload document:', error);
      toast.error(error.message || "Failed to upload document");
    } 
    finally {
      setLoading(false);
    }
  };

  //console.log("uploadedFile_length", uploadedFile);

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Add Document
          </div>
        </button>
      </div>

      <div className="bg-white px-4 py-3 ">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div className="row mb-3">
                <div className="col-md-12">
                  <label htmlFor="Upload File" className="form-label">
                    Upload File
                  </label>
                  <FileUpload onFileChange={(file) => setUploadedFiles(file)} />
                </div>
              </div>

              <div className="bg-white my-4">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="me-3 add_btn"
                    disabled={uploadedFiles === null || loading}
                  >
                    {loading ? (
                      <>
                        <BtnLoader />
                      </>
                    ) : (
                      "Add"
                    )}
                  </button>
                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={onCancel}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default AddDocumentComponent;



export const CommonShowDocument = ({
  refetchList,
  showPath,
  downloadPath,
  deletePath,
  type,
}) => {
  const { isDarkMode } = useTheme();
  // const [projects, setProjects] = useState();
  const [showProject, setShowProject] = useState(false);
  const [document, SetDocument] = useState([]);
  const handleShowProject = () => setShowProject(true); // Open filter
  const { reset } = useForm();
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  //console.log()("login_user in task:", login_user);
  // const { role: login_user_role } = login_user;
  //console.log()("login_user role in task:", login_user_role);

  const { id } = useParams();
  // console.log("documents_id :",id , id);

  // const { data: issue_detail, refetch } = useFetchIssueDetailViewQuery(id);
  // //console.log()("show log hours id", id);
  const fetchAllDocuments = async () => {
    try {
      const response = await fetchEntityById(showPath, id);
      //console.log()(response.data, "Documentttisuue");
      SetDocument(response?.data);
    } 
    catch (err) {
      // Show error in toast
      toast.error(err.message || "Failed to fetch subtasks");
    }
  };

  useEffect(() => {
    fetchAllDocuments();
  }, [id]);

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleImageClick = (clickedImageUrl) => {
    const images = document
      .filter((doc) =>
        /\.(jpg|jpeg|png|gif|bmp|webp)(\?.*)?$/i.test(doc.doc_url)
      )
      .map((doc) => ({
        src: doc.doc_url, // Lightbox expects an array of objects with "src"
      }));

    const clickedIndex = images.findIndex((img) => img.src === clickedImageUrl);

    setLightboxImages(images); // Set all images
    setCurrentImageIndex(clickedIndex); // Set the index of the clicked image
    setLightboxOpen(true); // Open the lightbox
  };

  const handleDownload = async (documentId, documentName) => {
    try {
      const response = await fetchEntityById(downloadPath, documentId);

      if (!response.status) {
        throw new Error(response.message || "Failed to fetch document URL");
      }

      const { doc_url } = response;

      if (!doc_url) {
        throw new Error("Document URL not found");
      }

      let downloadUrl = doc_url;
      try {
        const apiBase = process.env.REACT_APP_API_BASE_URL;
        if (apiBase) {
          const apiOrigin = new URL(apiBase).origin;
          if (downloadUrl.startsWith(apiOrigin)) {
            // Replace absolute origin with a relative path to trigger same-origin download (avoiding CORS)
            downloadUrl = downloadUrl.replace(apiOrigin, "");
          }
        }
      } 
      catch (e) {
        console.error("Failed to parse API base URL for download path:", e);
      }

      // Try fetching as a blob to force local download
      const fileResponse = await fetch(downloadUrl);
      if (!fileResponse.ok) {
        throw new Error("Network response was not ok");
      }
      const blob = await fileResponse.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = documentName || "downloaded-file";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);

      toast.success("Document downloaded successfully");
    } catch (err) {
      console.warn("Blob download failed, falling back to opening in a new tab:", err);
      try {
        const response = await fetchEntityById(downloadPath, documentId);
        if (response?.doc_url) {
          openInNewTab(response.doc_url);
          toast.success("Document opened in new tab");
          return;
        }
      } catch (fallbackErr) {
        // Ignore fallback error
      }
      toast.error(err.message || "Failed to download document");
    }
  };

  const handleDelete = async (documentId, documentName) => {
    const cleanName = documentName ? documentName.trim() : "this document";
    const truncatedName = cleanName.length > 50 ? cleanName.substring(0, 50) + "..." : cleanName;

    Swal.fire({
      title: "Confirm Deletion",
      html: `Are you sure you want to delete the document<br/>"<strong>${truncatedName}</strong>"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "Cancel",
      showCloseButton: true,
      customClass: {
        popup: "custom-swal-popup",
        title: "custom-swal-title",
        htmlContainer: "custom-swal-html",
        icon: "custom-swal-icon",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteCommentEntities(deletePath, documentId);
          // Update the state by filtering out the deleted document
          SetDocument((prevDocs) =>
            prevDocs.filter((doc) => doc.document_id !== documentId)
          );
          refetchList();
          toast.success("Document deleted successfully");
        } catch (err) {
          toast.error(err.message || "Failed to delete document");
        }
      }
    });
  };

  const handleDocumentAdded = () => {
    fetchAllDocuments(); // Re-fetch documents when a new one is added
    setShowProject(false);
  };

  return (
    <>
      <Offcanvas
        show={showProject}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          <AddDocumentComponent
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
            onDocumentAdded={handleDocumentAdded}
            refetchList={refetchList}
            type={type}
            id={id}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      <Box
        className="d-flex justify-content-end align-items-center gap-2"
        sx={{
          border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
          borderRadius: "6px",
          padding: "12px 16px",
          marginTop: "10px",
          marginBottom: "12px",
          backgroundColor: isDarkMode ? "transparent" : "#fff",
        }}
      >
        <button className="add_btn my-0" onClick={handleShowProject}>
          Add Attachment
        </button>
      </Box>

      {document?.length > 0 ? (
        <div className="row p-2">
          {document.map((doc) => {
            const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)(\?.*)?$/i.test(
              doc.doc_url
            );

            return (
              <div
                key={doc.document_id}
                className="col-md-4 col-lg-3 document_shadow gap-5 m-2 p-3"
                style={{
                  border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
                  borderRadius: "8px",
                  backgroundColor: isDarkMode ? "transparent" : "#fff",
                }}
              >
                <div className="d-flex gap-3 align-items-center">
                  <Avatar
                    src={doc.image_url}
                    alt={doc.owner_name?.charAt(0).toUpperCase()}
                  ></Avatar>
                  <label className="pe-2 text-nowrap">{doc.owner_name}</label>
                </div>
                <div className="d-flex justify-content-end">
                  <small className="text-rgba-gray text-end  ">
                    {new Date(doc.added_at).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </small>
                </div>
                {/* <div className="pe-3 my-3 border-1">
                  <label>{doc.document_name}</label>
                </div> */}

                {/* Show Image Preview If File is an Image */}
                {isImage ? (
                  <div className="text-center">
                    <img
                      src={doc.doc_url}
                      alt={doc.document_name}
                      className="doc_image"
                      onClick={() => handleImageClick(doc.doc_url)}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                ) : (
                  <div className="d-flex align-items-center py-4">
                    <span>📄 Document</span>{" "}
                    {/* Placeholder for non-image files */}
                  </div>
                )}

                {/* Buttons */}
                <div className="d-flex align-items-center justify-content-end mt-3">
                  <Tooltip title="Download">
                    <button
                      className="R_btn downloadicon_bg rounded-circle me-3"
                      onClick={() => handleDownload(doc.document_id, doc.document_name)}
                    >
                      <LuDownload className="text-rgba-green" />
                    </button>
                  </Tooltip>
                  
                  <Tooltip title="Delete">
                    <button
                      className="R_btn deleteicon_bg rounded-circle"
                      onClick={() => handleDelete(doc.document_id, doc.document_name)}
                    >
                      <RiDeleteBin6Line color="red" />
                    </button>
                  </Tooltip>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="d-flex flex-column align-items-center justify-content-center py-5 text-rgba-gray w-100">
          <IoDocumentTextOutline className="mb-2" style={{ fontSize: "64px", color: "rgba(4, 161, 137, 0.6)" }} />
          <span style={{ fontSize: "16px", fontWeight: "500", color: "#626161" }}>No documents available..</span>
        </div>
      )}
      
      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={lightboxImages}
        index={currentImageIndex}
        on={{
          view: ({ index }) => setCurrentImageIndex(index),
        }}
        plugins={lightboxImages.length > 1 ? [Zoom, Counter] : [Zoom]}
        render={{
          buttonPrev: lightboxImages.length <= 1 ? () => null : undefined,
          buttonNext: lightboxImages.length <= 1 ? () => null : undefined,
        }}
        zoom={{
          maxZoomPixelRatio: 5,
          scrollToZoom: true,
        }}
      />
    </>
  );
};
